'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isPlainObject = require('../predicate/isPlainObject.js');
function flattenObject(object) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_delimiter = _ref.delimiter, delimiter = _ref_delimiter === void 0 ? '.' : _ref_delimiter;
    return flattenObjectImpl(object, '', delimiter);
}
function flattenObjectImpl(object, prefix, delimiter) {
    var result = {};
    var keys = Object.keys(object);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = object[key];
        var prefixedKey = prefix ? "".concat(prefix).concat(delimiter).concat(key) : key;
        if (isPlainObject.isPlainObject(value) && Object.keys(value).length > 0) {
            Object.assign(result, flattenObjectImpl(value, prefixedKey, delimiter));
            continue;
        }
        if (Array.isArray(value)) {
            Object.assign(result, flattenObjectImpl(value, prefixedKey, delimiter));
            continue;
        }
        result[prefixedKey] = value;
    }
    return result;
}
exports.flattenObject = flattenObject;
